// Height value for study material description block, shows 'Show more' button if the content exceeds this height
// Type: INTEGER
export const STUDY_MATERIAL_DESCRIPTION_BLOCK_HEIGHT = 100